import { useParams, Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import SEO, { SITE_URL } from "@/components/base/SEO";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { articleContent } from "@/mocks/articleData";
import { articleCards } from "@/mocks/categories";

const articleImages: Record<string, string> = {
  "article-what-is-01": "https://readdy.ai/api/search-image?query=Modern%20sleek%20laptop%20on%20bright%20white%20desk%20displaying%20colorful%20spreadsheet%20interface%2C%20sunlit%20office%20with%20green%20plants%20in%20background%2C%20clean%20productive%20workspace%2C%20fresh%20contemporary%20photography%2C%20airy%20open%20atmosphere%2C%20professional%20blogger%20setup%2C%20no%20visible%20text%20content%20on%20screen&width=900&height=500&seq=article-what-is-hero-v2&orientation=landscape",
  "article-how-to-01": "https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20typing%20on%20silver%20laptop%20keyboard%20with%20warm%20tungsten%20desk%20lamp%20glow%2C%20cozy%20evening%20workspace%20atmosphere%2C%20notebook%20and%20coffee%20nearby%2C%20focused%20productive%20mood%2C%20intimate%20editorial%20photography%2C%20golden%20ambient%20lighting%2C%20no%20visible%20screen%20text&width=900&height=500&seq=article-how-to-hero-v2&orientation=landscape",
  "article-compare-01": "https://readdy.ai/api/search-image?query=Two%20identical%20tablets%20side%20by%20side%20on%20charcoal%20gray%20desk%20surface%20showing%20different%20interfaces%2C%20split%20screen%20comparison%20concept%2C%20modern%20tech%20review%20setup%2C%20clean%20bright%20office%20lighting%2C%20professional%20product%20comparison%20photography%2C%20minimalist%20composition%2C%20screens%20showing%20abstract%20colorful%20layouts&width=900&height=500&seq=article-compare-hero-v2&orientation=landscape",
  "article-safety-01": "https://readdy.ai/api/search-image?query=Metallic%20padlock%20on%20dark%20slate%20surface%20with%20soft%20blue%20ambient%20backlight%2C%20security%20and%20trust%20concept%2C%20dramatic%20low%20key%20photography%2C%20sleek%20modern%20aesthetic%2C%20subtle%20reflections%20on%20metal%2C%20cyber%20security%20atmosphere%2C%20clean%20minimal%20composition&width=900&height=500&seq=article-safety-hero-v2&orientation=landscape",
  "article-mistakes-01": "https://readdy.ai/api/search-image?query=Person%20holding%20head%20in%20hands%20looking%20frustrated%20at%20laptop%20screen%20on%20cluttered%20desk%2C%20soft%20natural%20window%20light%2C%20relatable%20authentic%20moment%2C%20warm%20documentary%20style%20photography%2C%20genuine%20emotion%20captured%2C%20educational%20content%20mood%2C%20no%20visible%20screen%20details&width=900&height=500&seq=article-mistakes-hero-v2&orientation=landscape",
  "article-why-01": "https://readdy.ai/api/search-image?query=Split%20composition%20showing%20traditional%20ecommerce%20website%20on%20left%20and%20clean%20organized%20spreadsheet%20on%20right%2C%20modern%20dual%20monitor%20desk%20setup%2C%20bright%20professional%20lighting%2C%20comparison%20concept%20photography%2C%20crisp%20clear%20contrast%20between%20interfaces%2C%20minimalist%20tech%20workspace&width=900&height=500&seq=article-why-hero-v2&orientation=landscape",
  "article-finds-01": "https://readdy.ai/api/search-image?query=Treasure%20chest%20overflowing%20with%20stylish%20fashion%20accessories%20sneakers%20and%20designer%20items%2C%20magical%20golden%20glow%20emerging%2C%20whimsical%20yet%20premium%20product%20photography%2C%20dark%20atmospheric%20background%20with%20warm%20spotlight%2C%20discovery%20and%20luxury%20concept%2C%20rich%20colors%20and%20textures&width=900&height=500&seq=article-finds-hero-v2&orientation=landscape",
  "article-sneakers-01": "https://readdy.ai/api/search-image?query=Colorful%20collection%20of%20sneakers%20in%20various%20styles%20arranged%20in%20rainbow%20gradient%20on%20white%20studio%20surface%2C%20bright%20even%20commercial%20lighting%2C%20sneakerhead%20culture%20photography%2C%20vibrant%20energetic%20composition%2C%20every%20pair%20perfectly%20positioned%2C%20celebratory%20footwear%20aesthetic&width=900&height=500&seq=article-sneakers-hero-v2&orientation=landscape",
  "article-clothing-01": "https://readdy.ai/api/search-image?query=Organized%20clothing%20rack%20with%20coordinated%20outfits%20including%20hoodies%20jackets%20and%20pants%20in%20earth%20tones%2C%20boutique%20store%20display%20aesthetic%2C%20warm%20ambient%20lighting%20from%20track%20lights%2C%20stylish%20retail%20photography%2C%20curated%20fashion%20collection%2C%20clean%20modern%20interior%20background&width=900&height=500&seq=article-clothing-hero-v2&orientation=landscape",
  "article-bags-01": "https://readdy.ai/api/search-image?query=Luxurious%20designer%20inspired%20handbag%20in%20cream%20leather%20with%20gold%20chain%20strap%20on%20black%20velvet%20background%2C%20dramatic%20spotlight%20illumination%2C%20high%20end%20product%20photography%2C%20elegant%20sophisticated%20aesthetic%2C%20rich%20texture%20details%20visible%2C%20exclusive%20luxury%20mood%2C%20no%20logos&width=900&height=500&seq=article-bags-hero-v2&orientation=landscape",
  "article-cheap-01": "https://readdy.ai/api/search-image?query=Scattered%20coins%20and%20folded%20dollar%20bills%20surrounding%20a%20stylish%20white%20sneaker%20and%20folded%20t-shirt%20on%20light%20wood%20surface%2C%20budget%20smart%20shopping%20concept%2C%20bright%20natural%20window%20light%2C%20clever%20financial%20lifestyle%20photography%2C%20warm%20optimistic%20mood%2C%20value%20and%20quality%20balance&width=900&height=500&seq=article-cheap-hero-v2&orientation=landscape",
  "article-vscss-01": "https://readdy.ai/api/search-image?query=Two%20smartphones%20lying%20parallel%20on%20dark%20matte%20surface%20each%20displaying%20different%20shopping%20app%20interfaces%2C%20versus%20battle%20concept%2C%20sleek%20tech%20comparison%20photography%2C%20dramatic%20side%20lighting%2C%20modern%20competitive%20analysis%20aesthetic%2C%20abstract%20colorful%20screen%20content&width=900&height=500&seq=article-vscss-hero-v2&orientation=landscape",
  "article-customs-01": "https://readdy.ai/api/search-image?query=Brown%20cardboard%20shipping%20box%20with%20international%20customs%20declaration%20sticker%20on%20rustic%20wooden%20table%2C%20soft%20natural%20window%20light%2C%20documentary%20style%20product%20photography%2C%20neutral%20honest%20aesthetic%2C%20global%20shipping%20concept%2C%20practical%20everyday%20mood%2C%20clean%20simple%20composition&width=900&height=500&seq=article-customs-hero-v2&orientation=landscape",
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const { pathname } = useLocation();
  const article = slug ? articleContent[slug] : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (!article) {
    return (
      <div className="min-h-screen bg-background-50">
        <SEO
          title="Article Not Found - Sugargoo Spreadsheet Directory"
          description="The requested article was not found. Browse our Sugargoo Spreadsheet guides, comparisons, and safety articles from the homepage."
          canonicalPath={pathname}
          ogType="website"
        />
        <Header />
        <main className="pt-24 pb-20">
          <div className="max-w-3xl mx-auto px-6 text-center">
            <h1 className="font-heading text-3xl font-bold text-foreground-900 mb-4">Article Not Found</h1>
            <p className="text-foreground-600 mb-6">The article you are looking for does not exist yet. Please check the URL or browse our available guides from the homepage.</p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              Back to Homepage
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  const relatedArticles = articleCards.filter((a) => a.slug !== slug).slice(0, 3);
  const cardData = articleCards.find((c) => c.slug === slug);
  const articleDescription = cardData?.excerpt || article.sections[0]?.content.slice(0, 160);
  const isoDate = new Date(article.date).toISOString();

  const articleJsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": SITE_URL },
          { "@type": "ListItem", "position": 2, "name": "Guides", "item": `${SITE_URL}/#article-hub` },
          { "@type": "ListItem", "position": 3, "name": article.title }
        ]
      },
      {
        "@type": "Article",
        "headline": article.title,
        "description": articleDescription,
        "author": { "@type": "Organization", "name": "Sugargoo Spreadsheet Directory", "url": SITE_URL },
        "publisher": { "@id": `${SITE_URL}/#organization` },
        "datePublished": isoDate,
        "dateModified": isoDate,
        "mainEntityOfPage": { "@type": "WebPage", "@id": `${SITE_URL}/guide/${slug}` },
        "about": "Sugargoo Spreadsheet",
        "wordCount": article.sections.reduce((count, s) => count + s.content.split(" ").length, 0),
        "articleSection": article.sections.map((s) => s.heading)
      }
    ]
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SEO
        title={`${article.title} - Sugargoo Spreadsheet Directory`}
        description={articleDescription}
        keywords={`sugargoo spreadsheet, ${slug.replace(/-/g, " ")}, sugargoo guide, spreadsheet shopping, replica finds`}
        canonicalPath={`/guide/${slug}`}
        ogType="article"
        articlePublishedTime={isoDate}
        articleModifiedTime={isoDate}
        jsonLd={articleJsonLd}
      />
      <Header />
      <main>
        <article>
          <header className="pt-28 pb-10 md:pt-32 md:pb-14 bg-background-100">
            <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
              <div className="flex items-center justify-center gap-3 mb-4 text-sm text-foreground-500">
                <span>{article.date}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                <span>{article.readTime}</span>
              </div>
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight mb-4">
                {article.title}
              </h1>
              <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
                <Link to="/" className="text-primary-500 hover:underline font-medium">
                  Sugargoo Spreadsheet homepage
                </Link>
                {" "}&mdash; return to the main directory to browse all categories and spreadsheet links.
              </p>
            </div>
          </header>

          <div className="max-w-4xl mx-auto px-6 md:px-10 py-10 md:py-16">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
              <aside className="lg:col-span-4">
                <div className="sticky top-24">
                  <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
                    Guide Article
                  </span>
                  <div className="rounded-2xl overflow-hidden aspect-[4/3] mb-6">
                    <img
                      src={articleImages[article.imageSeq] || articleImages["article-what-is-01"]}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <nav className="space-y-2">
                    <p className="text-xs uppercase tracking-widest text-foreground-500 mb-3">In This Article</p>
                    {article.sections.map((section, i) => (
                      <a
                        key={i}
                        href={`#section-${i}`}
                        className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors leading-snug"
                      >
                        {section.heading}
                      </a>
                    ))}
                  </nav>
                </div>
              </aside>

              <div className="lg:col-span-8">
                {article.sections.map((section, i) => (
                  <section key={i} id={`section-${i}`} className="mb-10">
                    <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-4">
                      {section.heading}
                    </h2>
                    <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                      {section.content}
                    </p>
                  </section>
                ))}

                <div className="my-14 p-6 md:p-8 rounded-2xl bg-secondary-50">
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                    Ready to Browse Spreadsheets?
                  </h3>
                  <p className="text-sm text-foreground-600 mb-5">
                    Return to the <Link to="/" className="text-primary-500 hover:underline font-medium">Sugargoo Spreadsheet homepage</Link> to explore all 14 product categories and find curated spreadsheet links for sneakers, clothing, bags, and more.
                  </p>
                  <Link
                    to="/"
                    className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-arrow-left-line"></i>
                    Back to Home
                  </Link>
                </div>

                {article.faqs.length > 0 && (
                  <section className="mb-10">
                    <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-6">
                      Frequently Asked Questions
                    </h2>
                    <div className="space-y-4">
                      {article.faqs.map((faq, i) => (
                        <details key={i} className="group rounded-xl bg-background-100 p-5 cursor-pointer">
                          <summary className="font-heading text-sm md:text-base font-semibold text-foreground-900 list-none flex items-center justify-between gap-3">
                            {faq.question}
                            <i className="ri-add-line text-foreground-500 group-open:hidden"></i>
                            <i className="ri-subtract-line text-foreground-500 hidden group-open:block"></i>
                          </summary>
                          <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
                            {faq.answer}
                          </p>
                        </details>
                      ))}
                    </div>
                  </section>
                )}
              </div>
            </div>
          </div>
        </article>

        {relatedArticles.length > 0 && (
          <section className="py-16 md:py-24 bg-background-100">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8">
                Related Articles
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {relatedArticles.map((card) => (
                  <Link
                    key={card.slug}
                    to={`/guide/${card.slug}`}
                    className="group block rounded-xl md:rounded-2xl overflow-hidden bg-background-50 cursor-pointer transition-all duration-300 hover:-translate-y-1"
                  >
                    <div className="p-4 md:p-5">
                      <span className="text-xs text-accent-600 font-medium">{card.readTime}</span>
                      <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mt-2 leading-snug">
                        {card.title}
                      </h3>
                      <p className="text-xs md:text-sm text-foreground-600 mt-2 leading-relaxed line-clamp-2">
                        {card.excerpt}
                      </p>
                      <span className="inline-block mt-3 text-xs text-primary-500 font-medium group-hover:underline">
                        Read Article &rarr;
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer />
    </div>
  );
}